import { render, staticRenderFns } from "./Delete_Project.vue?vue&type=template&id=9db31cd0&"
import script from "./Delete_Project.vue?vue&type=script&lang=js&"
export * from "./Delete_Project.vue?vue&type=script&lang=js&"
import style0 from "./Delete_Project.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports